'use strict';

const LOG_NUMBER_LINE_PATTERN = /\n[^\n]*\d{10,}-[A-Za-z0-9]+\s*$/;

export function stripLogNumber (text) {
    return text.replace(LOG_NUMBER_LINE_PATTERN, '').trim();
}

